"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomBanner = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

require("./BottomBanner.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var BottomBanner = function BottomBanner(_ref) {
  var bannerClass = _ref.bannerClass,
      bannerColor = _ref.bannerColor,
      labelColor = _ref.labelColor,
      labelMessage = _ref.labelMessage,
      labelClass = _ref.labelClass,
      buttonClass = _ref.buttonClass,
      buttonContent = _ref.buttonContent,
      buttonAction = _ref.buttonAction,
      children = _ref.children;
  var color = bannerColor ? bannerColor : _atoms.Color.Sky;
  var messageClass = labelClass ? labelClass : 'bottom-banner-message';
  var messageColor = labelColor ? labelColor : _atoms.Color.White2;
  var additionalStyles = {
    background: "var(--".concat(color, ")")
  };
  (0, _react.useEffect)(function () {
    var rootElementDiv = document.getElementById('root');

    if (rootElementDiv) {
      rootElementDiv.classList.add('bottom-banner-used');
    }

    return function () {
      if (rootElementDiv) rootElementDiv.classList.remove('bottom-banner-used');
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    trkContext: "Bottom Banner",
    className: "BottomBanner ".concat(bannerClass ? bannerClass : ''),
    styles: additionalStyles,
    alignItems: "center",
    justifyContent: "center"
  }, labelMessage && /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: messageClass
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    color: messageColor,
    content: labelMessage
  })), /*#__PURE__*/_react.default.createElement(_atoms.Column, null, buttonContent && buttonAction && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: true,
    className: buttonClass,
    small: true,
    marginLeft: "2",
    content: buttonContent,
    onClick: buttonAction
  })), children);
};

exports.BottomBanner = BottomBanner;